import { components } from "@certn/legacy-api/generated-schemas/people";

import { EmploymentHistoryInputField } from "./EmploymentHistoryInputField";
import { EmploymentHistorySummaryField } from "./EmploymentHistorySummaryField";
import { FieldType } from "../types";

export function EmploymentHistoryField(
  field: components["schemas"]["EmploymentCheckField"]
): FieldType<components["schemas"]["EmploymentCheckField"]> {
  return {
    field,
    inputElement: (
      <EmploymentHistoryInputField key={field.name} field={field} />
    ),
    summaryElement: () => (
      <EmploymentHistorySummaryField
        key={field.name + "_summary_field"}
        field={field}
      />
    ),
    initialValue: field.value,
  };
}
